<template>
  <section class="app-main">

      <router-view v-slot="{ Component }">
        <transition name="fade-transform" mode="out-in">
          <div>
            <component :is="Component" />
          </div>
        </transition>
      </router-view>

  </section>
</template>

<script setup lang="ts">

</script>

<style lang="scss" scoped>
  .app-main{
    box-sizing: border-box;
      height: 98%;
    >div{
        height: 98%;
    }
  }
</style>
